"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const core_1 = require("@material-ui/core");
const ri_1 = require("react-icons/ri");
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("@material-ui/core/styles");
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    content: {
        backgroundColor: '#F8F4F4',
    },
    success: {
        borderBottom: `2px solid ${theme.palette.success.main}`,
    },
    error: {
        borderBottom: `2px solid ${theme.palette.error.main}`,
    },
    info: {
        borderBottom: `2px solid ${theme.palette.info.main}`,
    },
    draft: {
        borderBottom: `2px solid ${theme.palette.warning.main}`,
    },
}));
const defaultOptions = {
    anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
    },
    autoHideDuration: 6000,
    message: undefined,
    variant: null,
};
function SnackbarMessage(props) {
    const { message } = props;
    const classes = useStyles();
    const theme = (0, core_1.useTheme)();
    const [open, setOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if ((message === null || message === void 0 ? void 0 : message.body) && !(message === null || message === void 0 ? void 0 : message.seen)) {
            setOpen(true);
            message.seen = true;
        }
    }, [message]);
    const renderMessage = () => {
        if (Array.isArray(message.body)) {
            return message.body.map((m, i) => (react_1.default.createElement(core_1.Typography, { key: i, variant: "body1", component: "li" }, m)));
        }
        else {
            return react_1.default.createElement(core_1.Typography, { variant: "body1" }, message.body);
        }
    };
    const renderIcon = () => {
        switch (message.variant) {
            case 'success':
                return (react_1.default.createElement(ri_1.RiCheckboxCircleLine, { className: "mr-4", color: theme.palette.success.main, size: "1.5rem" }));
            case 'error':
                return (react_1.default.createElement(ri_1.RiErrorWarningLine, { className: "mr-4", color: theme.palette.error.main, size: "1.5rem" }));
            case 'info':
                return (react_1.default.createElement(ri_1.RiInformationLine, { className: "mr-4", color: theme.palette.info.main, size: "1.5rem" }));
            case 'draft':
                return (react_1.default.createElement(ri_1.RiCheckboxCircleLine, { className: "mr-4", color: theme.palette.warning.main, size: "1.5rem" }));
            default:
                return null;
        }
    };
    return (react_1.default.createElement(core_1.Snackbar, { ...{ ...defaultOptions, ...message }, open: open, onClose: () => setOpen(false), ContentProps: {
            variant: 'body2',
            headlineMapping: {
                body1: 'div',
                body2: 'div',
            },
        } },
        react_1.default.createElement(core_1.SnackbarContent, { className: (0, clsx_1.default)(classes.content, classes[message.variant]), message: react_1.default.createElement("div", { className: "flex items-center" },
                react_1.default.createElement("div", null, renderIcon()),
                react_1.default.createElement("div", null,
                    message.title && react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, message.title),
                    react_1.default.createElement("div", null, renderMessage())),
                react_1.default.createElement("div", { className: "ml-4" },
                    react_1.default.createElement(core_1.IconButton, { "aria-label": "Close", color: "inherit", onClick: () => setOpen(false) },
                        react_1.default.createElement(ri_1.RiCloseLine, { size: "1.5rem", className: "text-black" })))) })));
}
SnackbarMessage.defaultProps = {
    message: {},
};
SnackbarMessage.propTypes = {
    message: prop_types_1.default.any,
};
exports.default = react_1.default.memo(SnackbarMessage);
